// extracted by mini-css-extract-plugin
export default {"loader_mask":"loader_loader_mask__aYj4n","loader":"loader_loader__0Ak7d","load4":"loader_load4__HOFUO"};